import whenDomReady from 'when-dom-ready';
function initialise() {
    const categories = document.querySelectorAll('.js-license-tiers__category');
    if (categories.length === 0) {
        return;
    }
    categories.forEach((category) => {
        const title = category.querySelector('.js-license-tiers__category-title');
        if (title === null)
            return;
        category.addEventListener('click', () => togglePlusMinus(category, title));
    });
    function togglePlusMinus(category, title) {
        const icon = title.querySelector('.js-license-tiers__category-title-icon');
        if (icon === null)
            return;
        const categoryTexts = category.querySelectorAll('.js-license-tiers__category-content-text');
        if (categoryTexts.length === 0) {
            return;
        }
        icon.classList.toggle('minus');
        categoryTexts.forEach((text) => {
            text.classList.toggle('shown');
        });
        updateTabHeight();
    }
    // When the content height changes inside the tab
    function updateTabHeight() {
        const track = document.querySelector('.tns-ovh');
        const activeTab = track.querySelector('.tns-slide-active');
        if (!track) {
            return;
        }
        track.style.height = activeTab.clientHeight + 'px';
    }
}
whenDomReady().then(initialise);
